import React, { useState, useEffect } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import {
  Document,
  Image,
  Note,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";

const TestPDF = ({ data }) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  const [items, setItems] = useState(["Initial Item"]);
  const styles = StyleSheet.create({
    page: {
      fontFamily: "Helvetica",
      fontSize: 12,
      padding: "0px",
      position: "relative",
    },
    container: {
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      textAlign: "center",
    },
    title: {
      fontSize: 24,
      fontWeight: "bold",
      marginBottom: "10px",
      paddingTop: "100px",
    },
    subtitle: {
      fontSize: 16,
      fontWeight: "bold",
      marginBottom: "20px",
    },
    certificateImage: {
      width: "100px",
      height: "auto",
      marginBottom: "20px",
    },
    whatHasBeenDone: {
      fontSize: 10,
      fontWeight: "semibold",
      marginBottom: "10px",
      color: "rgb(150,150,150)",
    },
    recipientName: {
      fontSize: 30,
      fontWeight: "semibold",
      marginBottom: "10px",

      color: "rgb(60,60,60)",
    },
    signature: {
      fontSize: 12,
      marginTop: "80px",
      color: "rgb(60,60,60)",
      paddingBottom: "50px",
    },
    courseName: {
      fontSize: 15,
      color: "rgb(100,100,100)",
      fontWeight: "bold",
    },
    courseInsight: {
      fontSize: 10,
      fontWeight: "semibold",
      marginTop: "15px",
      color: "rgb(150,150,150)",
    },
    pageBackground: {
      position: "absolute",
      minWidth: "100%",
      minHeight: "100%",
      display: "block",
      height: "100%",
      width: "100%",
    },
  });

  const pdf = (
    <>
      {isClient && (
        <Document>
          <Page size="A4" orientation="portrait" style={styles.page}>
            <View style={styles.container}>
              <img
                src="/assets/certificate/phyzick171100100.jpg"
                style={styles.pageBackground}
              />

              <Text style={styles.title}>Certificado de Curso</Text>
              <img
                style={styles.certificateImage}
                src="/assets/logos/sidebar-logo.png" // Replace with your certificate image URL
              />

              <View
                style={{
                  flexDirection: "column",
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <Text style={styles.subtitle}>
                  Monstruo Creativo Academy certifica que:{" "}
                </Text>
                <Text style={styles.recipientName}>{/**Nombre */}</Text>
                <Text style={styles.whatHasBeenDone}>
                  Ha completado exitosamente el curso:
                </Text>
                <Text style={styles.courseName}> {/**Titulo */}</Text>
                <Text style={styles.courseInsight}>
                  an online non-credit course authorized by Meta and offered
                  through Coursera
                </Text>
              </View>

              <Text style={styles.signature}>
                Instructor: {/**Instructor */}
              </Text>
            </View>
          </Page>
        </Document>
      )}
    </>
  );

  return (
    <>
      {isClient ? (
        <div className=" mt-12  pb-20 mx-auto max-w-2xl">
          <div className=" w-full lg:max-w-full  p-4">
            {/* <div
              className=" h-72   flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
              style={{
                backgroundImage: ` url('${data.cursoInscrito.imagenDestacada.sizes.thumbnail.url}')`,
              }}
              title="Certificate"
            ></div> */}
                  <PDFViewer className=" w-full h-full min-h-screen" >
                  {pdf}
                </PDFViewer>
            <div className="border-r border-b border-l border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
              <div className="mb-8 ">
                <div className="flex justify-between  flex-wrap">
                  <p className="text-sm text-gray-600 flex items-center">
                    <svg
                      className="fill-current text-gray-500 w-3 h-3 mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M4 8V6a6 6 0 1 1 12 0v2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h1zm5 6.73V17h2v-2.27a2 2 0 1 0-2 0zM7 6v2h6V6a3 3 0 0 0-6 0z" />
                    </svg>
                    Solo tú
                  </p>
                  <p className=" text-gray-700  font-bold text-base flex items-center bg-blue-100 p-2 rounded-md">
                    {/* {data.usuario.nombres}
                     */}
                  </p>
                </div>
                

                <div className="text-green-600  text-md mb-0 mt-4">
                  Certificado
                </div>
                <div className="text-gray-900 font-bold text-xl mb-2">
                  {/**Titulo Curso */}
                </div>
                <div className="flex justify-start gap-4">
                  <p className="text-gray-700 text-base"> Estado:</p>
                  <p className="text-blue-700 text-base font-semibold">
                    {" "}
                    {/* Estado */}
                  </p>
                </div>
              </div>
              <div className="flex items-center">
                <PDFDownloadLink
                  className="bg-blue-600 rounded-md p-2 text-white font-semibold"
                  document={pdf}
                  fileName={"Certificado-MC-" + new Date().getTime() + ".pdf"}
                >
                  {({ blob, url, loading, error }) =>
                    loading ? "Cargando . . ." : "Descargar"
                  }
                </PDFDownloadLink>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default TestPDF;
